import React, { useContext, useState } from "react";

import { OfferOptionsContext } from "@gp/components";
import { SportCategoryOffer, SportOffer, TournamentOffer } from "@gp/offer";
import { useIsAdditionalOfferVisible } from "@utils/offer";
import classNames from "classnames";
import { observer } from "mobx-react";

import {
	OfferHistoryColumnsContext,
	getOfferHistoryColumns,
} from "./OfferHistoryColumnsContext";
import { TournamentBody } from "./TournamentBody";
import { TournamentHeader } from "./TournamentHeader";

export const TournamentEvents = observer(function TournamentEvents(props: {
	sport: SportOffer;
	category: SportCategoryOffer;
	tournament: TournamentOffer;
	hidden?: boolean;
}) {
	const [hidden, setHidden] = useState(false);

	const isAdditionalOfferVisible = useIsAdditionalOfferVisible();
	const offerOptionsContext = useContext(OfferOptionsContext);

	// @ts-expect-error isOfferHistory provided at runtime via SportsPageOptionsProvider, not on @gp/components OfferOptions type
	const isOfferHistory: boolean = offerOptionsContext.isOfferHistory;
	const historyColumns = isOfferHistory
		? getOfferHistoryColumns(props.tournament.events)
		: null;

	const tableClasses = classNames("offer offer--sports", {
		// "offer--sports": !props.sport.isLive,
		"offer--sports--live": props.sport.isLive,
		"offer--full": !isAdditionalOfferVisible,
		"offer--sml": isAdditionalOfferVisible,
		"is-collapsed": props.hidden, // !isTournamentShown
	});

	return (
		<OfferHistoryColumnsContext.Provider value={historyColumns}>
			<div className={tableClasses}>
				<TournamentHeader
					sport={props.sport}
					category={props.category}
					tournament={props.tournament}
					setHidden={setHidden}
					hidden={hidden}
					isAdditionalOfferVisible={isAdditionalOfferVisible}
				/>
				<TournamentBody tournament={props.tournament} hidden={hidden} />
			</div>
		</OfferHistoryColumnsContext.Provider>
	);
});
